/**
 * ZOD SCHEMAS cho Status Enums -- Single Source of Truth
 *
 * Import vào tRPC routers (backend) và form schemas (frontend)
 * thay vì hardcode z.enum([...]) hoặc z.string() cho status fields.
 */

import { z } from 'zod';
import {
  UserStatusValues,
  MachineStatusValues,
  QuotationStatusValues,
  OrderStatusValues,
  ProductionOrderStatusValues,
  RoutingStepStatusValues,
  MaterialPlanningStatusValues,
  MoldStatusValues,
  PrepressStatusValues,
  QCStatusValues,
  NCRStatusValues,
  OutsourcePOStatusValues,
  PaymentStatusValues,
  InventoryStatusValues,
  DocumentStatusValues,
  PurchaseOrderStatusValues,
  PurchaseRequestStatusValues,
  DeliveryStatusValues,
  DesignStatusValues,
  ToolingStatusValues,
  SpecStatusValues,
  ReadinessStatusValues,
  FeedbackStatusValues,
  KpiStatusValues,
  enumValues,
} from './enums';

// ── Zod Enum Schemas ──

export const userStatusSchema = z.enum(enumValues(UserStatusValues));
export const machineStatusSchema = z.enum(enumValues(MachineStatusValues));
export const quotationStatusSchema = z.enum(enumValues(QuotationStatusValues));
export const orderStatusSchema = z.enum(enumValues(OrderStatusValues));
export const productionOrderStatusSchema = z.enum(enumValues(ProductionOrderStatusValues));
export const routingStepStatusSchema = z.enum(enumValues(RoutingStepStatusValues));
export const materialPlanningStatusSchema = z.enum(enumValues(MaterialPlanningStatusValues));
export const moldStatusSchema = z.enum(enumValues(MoldStatusValues));
export const prepressStatusSchema = z.enum(enumValues(PrepressStatusValues));
export const qcStatusSchema = z.enum(enumValues(QCStatusValues));
export const ncrStatusSchema = z.enum(enumValues(NCRStatusValues));
export const outsourcePOStatusSchema = z.enum(enumValues(OutsourcePOStatusValues));
export const paymentStatusSchema = z.enum(enumValues(PaymentStatusValues));
export const inventoryStatusSchema = z.enum(enumValues(InventoryStatusValues));
export const documentStatusSchema = z.enum(enumValues(DocumentStatusValues));
export const purchaseOrderStatusSchema = z.enum(enumValues(PurchaseOrderStatusValues));
export const purchaseRequestStatusSchema = z.enum(enumValues(PurchaseRequestStatusValues));
export const deliveryStatusSchema = z.enum(enumValues(DeliveryStatusValues));
export const designStatusSchema = z.enum(enumValues(DesignStatusValues));
export const toolingStatusSchema = z.enum(enumValues(ToolingStatusValues));
export const specStatusSchema = z.enum(enumValues(SpecStatusValues));
export const readinessStatusSchema = z.enum(enumValues(ReadinessStatusValues));
export const feedbackStatusSchema = z.enum(enumValues(FeedbackStatusValues));
export const kpiStatusSchema = z.enum(enumValues(KpiStatusValues));

/**
 * statusUpdateSchema chuẩn -- thay thế z.string().min(1) cho status
 * Dùng khi entityType xác định tại runtime (không biết trước enum nào)
 * Vẫn chấp nhận string nhưng có message tiếng Việt rõ ràng
 */
export const statusUpdateSchema = z.object({
  id: z.string().min(1, 'ID không được để trống'),
  status: z.string().min(1, 'Trạng thái không được để trống'),
});
